import(/* webpackMode: "eager" */ "/Users/yiminghan/lavareach/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/yiminghan/lavareach/public/blog-images/how-to-get-local-seo-clients/image.png");
;
import(/* webpackMode: "eager" */ "/Users/yiminghan/lavareach/public/headshots/daniel_zhao.png");
